import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { language } from "language/default";
export const getEditModeActionBarListButtonsData = (params) => {
    const editMenu = [
        { className: "recenterButton",
            icon: "undo",
            isDisabled: !params.hasPast,
            key: "actionBarUndo",
            label: language.en.common.undo,
            onClick: params.onUndo,
            size: AuxButtonSizeEnum.REGULAR,
            style: { height: "auto" },
            type: AuxButtonTypeEnum.TERTIARY },
        { className: "recenterButton",
            // As of ADS 9.1, redo is not in the list of icon but present on the demo site
            icon: "redo",
            isDisabled: !params.hasFuture,
            isIconRight: true,
            key: "actionBarRedo",
            label: language.en.common.redo,
            onClick: params.onRedo,
            size: AuxButtonSizeEnum.REGULAR,
            type: AuxButtonTypeEnum.TERTIARY },
        { icon: "save",
            isDisabled: !params.hasPast,
            key: "actionBarSave",
            label: language.en.common.save,
            onClick: params.onSave,
            size: AuxButtonSizeEnum.SMALL,
            type: AuxButtonTypeEnum.PRIMARY },
        { icon: "delete-small",
            key: "actionBarClose",
            label: language.en.dashboard.edit.closeEditor,
            onClick: params.onCloseEditor,
            size: AuxButtonSizeEnum.SMALL,
            type: AuxButtonTypeEnum.SECONDARY }
    ];
    return editMenu;
};
